/** @jsx jsx */

import React, {
  Fragment as _,
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import setBlockProps from 'services/apiHelpers/setBlockProps';

interface IMediaContext {
  onMediaChange: () => void | null;
}

export const MediaContext = createContext({
  onMediaChange: null,
}) as any;

interface IMediaProps {
  id: string;
  onMediaChange?: (props: any) => void;
  children: any;
}
const Media = (props: IMediaProps) => {
  const mediaContext = useContext(MediaContext) as IMediaContext;

  const { children } = props;

  const onMediaChange =
    props?.onMediaChange || mediaContext.onMediaChange || null;

  const { parent, child } = useSelector((state: State) => {
    const parent = state.blocks[props.id];
    return {
      parent,
      child: parent?.props?.child,
    };
  });

  // const childRef = useRef<number | undefined>();
  // if (onMediaChange && typeof onMediaChange === 'function') {
  //   if (childRef.current !== child) {
  //     onMediaChange(child);
  //     childRef.current = child;
  //   }
  // }

  const isSafeToCallOnMediaChange = useRef(false);

  useEffect(() => {
    if (!children[child]) {
      console.log(
        `children[( index = ) ${child}] does not exist on legacy block. resetting media component to image`
      );
      setBlockProps(parent, { child: 1 });
    }
  }, [child]);

  useEffect(() => {
    // return;
    if (!onMediaChange || typeof onMediaChange !== 'function') {
      return;
    }

    if (isSafeToCallOnMediaChange.current) {
      onMediaChange(child);
    }

    isSafeToCallOnMediaChange.current = true;

    return () => {
      //
    };
  }, [child]);

  if (!children[child]) {
    // return null if child doesn't exist. reset in effect
    return null;
  }

  return children[child];
};

export default Media;
